import api from '../../api/apiSlice';
import { Coupon } from './Coupon';

export const couponsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    listCoupons: builder.query<Coupon[], void>({
      providesTags: ['Coupon'],
      query: () => '/coupon/list',
    }),
    detailsCoupon: builder.query<Coupon, string>({
      providesTags: ['Coupon'],
      query: (id) => `/coupon/${id}`,
    }),
    updateCoupon: builder.mutation<Coupon, { id: string; whitelisted?: boolean; description?: string }>({
      query: ({ id, whitelisted, description }) => ({
        url: `/coupon/${id}`,
        method: 'PUT',
        body: { whitelisted, description },
      }),
      invalidatesTags: ['Coupon'],
    }),
    syncCoupons: builder.mutation<void, void>({
      query: () => ({
        url: '/coupon/sync',
        method: 'POST',
      }),
      invalidatesTags: ['Coupon'],
    }),
  }),
});

export const { useListCouponsQuery, useDetailsCouponQuery, useSyncCouponsMutation, useUpdateCouponMutation } =
  couponsApi;
